// Footer.jsx
"use client";
import React from "react";
import { Box, useMediaQuery, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { VERSION, BUILD_DATE } from "../../../config/version";

function Footer({ hideCopyright = false }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const customizer = useSelector((state) => state.customizer);

  return (
    <Box
      component="footer"
      sx={{
        display: "flex",
        flexDirection: isDesktop ? "row" : "column",
        justifyContent: isDesktop ? "space-between" : "center",
        alignItems: "center",
        padding: isDesktop ? 1 : 2,
        marginLeft: 2.5,
        textAlign: isDesktop ? "left" : "center",
        backgroundColor: "transparent",
      }}
    >
      {!hideCopyright && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 2 }}>
          <Typography variant="body3" color={theme.palette.grey[400]}>
            © {new Date().getFullYear()} Meex, Inc. — Version {VERSION}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default Footer;
